// extracted by mini-css-extract-plugin
export var text = "_3j-0";